import React from 'react'
import image from "../assets/tanmay.jpg"
import ResumePdf from "../assets/resume.pdf"
import {LiaFileDownloadSolid} from 'react-icons/lia'

function About() {
  return (
    <div
      className=" pt-[80px] md:h-[650px] h-[1000px] font-Poppins "
      id="About"
    >
      <div className=" flex   md:flex-row flex-col md:justify-evenly  space-y-20  md:space-y-0  md:w-[100%] ">
        <div className=" flex flex-col ml-9 ">
          <div className=" font-bold  text-[50px] font-Poppinsb ">About Me</div>
          <p className=" text-[1rem] opacity-75">My Introduction</p>
          <div className="  max-w-[18rem] lg:max-w-[25rem] pt-[3rem] ">
            <p className="md:text-[1rem] text-[0.8rem]">
              Hey there,
              <br />
              I'm Tanmay, a 21-year-old CSE undergrad who is passionate about
              Software Development and UI/UX Design . Currently, I'm pursuing my
              career as a Full Stack Web Developer 👨🏻‍💻 , I'm also a Nature lover
              and protector . I share my learnings through speaking engagements
              and write-ups.
            </p>
            <div className="mt-[2rem]">
              <a href={ResumePdf} target="_blank" rel="noopener noreferrer">
                <div className="relative  ">
                  <button className="red-btn rounded-lg pl-8  py-4 px-14 ho">
                    Resume
                  </button>
                  <span className="absolute z-[50] left-[6rem] top-[19px] ">
                    <LiaFileDownloadSolid className="text-black1" size={20} />
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className=" image   mx-auto md:mx-0 ">
          <img
            src={image}
           
            className="h-[400px] p-[2rem]  -mt-4"
          />
        </div>
      </div>
    </div>
  );
}

export default About;